export interface EntityQueryResults<T> {
    totalEntities: number;
    currentPage: number;
    totalPages: number;
    entities: T[];
}

export const defaultEntityQueryResults: EntityQueryResults<any> = {
    totalEntities: 0,
    currentPage: 1,
    totalPages: 1,
    entities: []
}

export function EntityQueryResultsFromJSON(json: any, entityFromJSON: (json: any) => any): EntityQueryResults<any> {
    if((json === null) || (json === undefined)) {
        return json;
    }

    return {
        'totalEntities': json['totalEntities'],
        'currentPage': json['currentPage'],
        'totalPages': json['totalPages'],
        'entities': json['entities'].map(entityFromJSON)
    }
}